import React from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { AddAPhoto } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  uploaderContaienr: {
    width: 100,
    height: 100,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: '3px',
    borderStyle: 'dashed',
    borderColor: theme.palette.grey[400],
    borderRadius: '10px',
    cursor: 'pointer',
    '& svg': {
      color: theme.palette.grey[400],
    },
  },
}));

export default function ImagePlaceHolder({ handleClick, styles }) {
  const classes = useStyles();
  return (
    <Box className={classes.uploaderContaienr} style={{ ...styles }} onClick={handleClick}>
      <AddAPhoto />
    </Box>
  );
}
